import { Button } from '@/components/ui/button';
import { Pagination as BasePagination, PaginationContent, PaginationItem } from '@/components/ui/pagination';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';

export default function Pagination({ currentPage, totalPages, setPage }) {
  const goPage = page => () => {
    setPage(page);
  };

  return (
    <BasePagination className='mt-10 max-w-min'>
      <PaginationContent className='w-full justify-between gap-3'>
        <PaginationItem>
          <Button
            variant='ghost'
            className='group aria-disabled:pointer-events-none aria-disabled:opacity-50'
            aria-disabled={currentPage === 1 ? true : undefined}
            role={currentPage === 1 ? 'link' : undefined}
            disabled={currentPage === 1}
            onClick={goPage(+currentPage - 1)}
          >
            <ArrowLeftIcon
              className='-ms-1 opacity-60 transition-transform group-hover:-translate-x-0.5'
              size={16}
              aria-hidden='true'
            />
          </Button>
        </PaginationItem>
        <span className='text-zinc-500'>{currentPage}</span>
        <PaginationItem>
          <Button
            variant='ghost'
            className='group aria-disabled:pointer-events-none aria-disabled:opacity-50'
            aria-disabled={currentPage === totalPages ? true : undefined}
            role={currentPage === totalPages ? 'link' : undefined}
            disabled={currentPage === totalPages}
            onClick={goPage(+currentPage + 1)}
          >
            <ArrowRightIcon
              className='-me-1 opacity-60 transition-transform group-hover:translate-x-0.5'
              size={16}
              aria-hidden='true'
            />
          </Button>
        </PaginationItem>
      </PaginationContent>
    </BasePagination>
  );
}
